import SmartCollection from './smart_collection'
import DiscourseVote from './discourse_vote'

// @namespace Model
export default class DiscourseVotes extends SmartCollection {
  get model () {
    return DiscourseVote
  }

  /**
   * Discourse vote is a singleton resource. For every result, there is only one
   * vote model associated with it. Make the collection aware of this and
   * prevent two vote models with the same `result_id` from existing.
   */
  modelId (attrs) {
    return attrs.result_id
  }

  initialize (models = [], options = {}) {
    // Track parent
    this.poll = options.poll
  }

  url () {
    const participantKey = this.poll && this.poll.get('participant_key')
    if (participantKey && this.poll.type() === 'discourse') {
      return `/api/participant/discourses/${participantKey}/votes`
    } else {
      return ''
    }
  }
}
